var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showModalVisualizaPdf
        ? _c("app-modal-visualiza-pdf", {
            attrs: {
              titulo: _vm.tituloModal,
              tipo: _vm.tipoModal,
              isImagem: _vm.isImagem,
              conteudo: _vm.conteudoModal,
              conteudoSemId: _vm.conteudoModalSemid,
              isVTN: false
            },
            on: { closeModal: _vm.closeModalVisualizaPdf }
          })
        : _vm._e(),
      _c("app-divider", {
        attrs: {
          label: "Documentos",
          showBorder: true,
          addMarginTop: _vm.addMarginTop
        }
      }),
      _c(
        "el-table",
        { attrs: { data: _vm.documentos } },
        [
          _c("el-table-column", {
            attrs: {
              label: "Nome do arquivo:",
              prop: "tipoDocumento.descricao",
              "min-width": "280"
            }
          }),
          _c("el-table-column", {
            attrs: {
              label: "Tipo de documento",
              prop: "fileName",
              "min-width": "250"
            }
          }),
          _c("el-table-column", {
            attrs: { label: "Ações", prop: "quantidadeUPFPA", width: "80" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm.isProcessoFisico
                      ? _c("app-action-button", {
                          attrs: {
                            disabled: !_vm.isDocumentoParaVisualizacao(
                              scope.row
                            ),
                            cor: !_vm.isDocumentoParaVisualizacao(scope.row)
                              ? "#C0C4CC"
                              : "#666666",
                            icone: "eye",
                            text: !_vm.isDocumentoParaVisualizacao(scope.row)
                              ? "Não é possível exibir esse arquivo"
                              : "Visualizar",
                            fontSize: "18"
                          },
                          on: {
                            click: function($event) {
                              return _vm.abrirDocumento(scope.row)
                            }
                          }
                        })
                      : _vm._e(),
                    _c("app-action-button", {
                      attrs: {
                        icone: "download",
                        text: "Download",
                        fontSize: "18",
                        posicaoTooltip: "left"
                      },
                      on: {
                        click: function($event) {
                          return _vm.downloadDocumento(scope.row)
                        }
                      }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6fbd4caf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fbd4caf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/resumo/AppResumoDocumentos.vue
// module id = null
// module chunks = 